import UserDetails from "./UserDetails";
import { useSelector } from "react-redux";
import { currentSelectedLanguage } from "../../../../../StateManagement/actions";
import { useState, useEffect, useRef } from "react";
import APIRequest from "../../../../../Services/commonAPIConsumer";
import Alert from "../../../../Controls/Alerts/Alerts";
export default function AdminUsers() {
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const lookupDataRoleOptions = useSelector((state) => state.settings.lookupData);

  const [userRoleOptions, setUserRoleOptions] = useState([]);
  const [showUserDetails, setShowUserDetails] = useState(false);
  const [getUserDetails, setGetUserDetails] = useState({
    isSearch: false,
    userName: '',
    companyName: '',
    roleValue: '0',
    statusValue: ''
  });
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const userRole = localStorage.getItem("UserRole");

  const roleRef = useRef(null);
  const statusRef = useRef(null);
  const userNameRef = useRef(null);
  const companyNameRef = useRef(null);
  const userDetailsRef = useRef(null);

  useEffect(() => {
    const fetchUserRoles = async () => {
      const url = `${process.env.REACT_APP_API}${process.env.REACT_APP_API_GetAdminLookUpDetails}`;
      const response = await APIRequest.GET(
        "",
        `${url}?Lang=${localStorage.getItem("language")}`
      );
      setUserRoleOptions(response?.userRoles);
    };

    fetchUserRoles();
  }, []);

  // useEffect(() => {
  //   setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  // }, [alertType]);


  const onSearchHandler = () => {
    if (
      userRole === "RDocsSupportAdmin" &&
      companyNameRef.current?.value === "" &&
      userNameRef.current?.value === ""
    ) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_validateCompanyOrUser
      );
      setAlertType("warning");
      setShowUserDetails(false);
      return;
    }
    setShowUserDetails(true);
    let roleValue = "0";
    const selectedRole = userRoleOptions.find(
      (role) => role.roleName === roleRef.current.value
    );
    if (selectedRole) {
      roleValue = selectedRole.id;
    }
    setGetUserDetails({
      isSearch: true,
      userName: userNameRef.current?.value || '',
      companyName: companyNameRef.current?.value || '',
      roleValue: roleValue || '0',
      statusValue: statusRef.current?.value || ''
    });

    // userDetailsRef.current?.getUserDetails(
    //   userNameRef.current?.value || '',
    //   companyNameRef.current?.value || '',
    //   roleValue || '0',
    //   statusRef.current?.value || ''
    // );
  };




  return (
    <>
      <Alert
        alertMsg={alertMsg}
        alertType={alertType}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className="alerthist"
        isfromSeetting="true"></Alert>
      <div className="tab-pane fade rounded show active p-2"
        id="v-tabs-users"
        role="tabpanel"
        aria-labelledby="v-tabs-users-tab">

        <div className="align-items-center bg-white mt-5 p-2 row">
          {userRole === "RDocsCustomerAdmin" && (
            <>
              <div className="col-sm-8 row">
                <div className="col-sm-4 p-2">
                  <select
                    className="form-select form-control red-shadow border-r4"
                    ref={roleRef}
                    id="ddlRoles"
                    aria-label="Default select example"
                    defaultValue={0}>
                    {lookupDataRoleOptions?.roleOptions?.map((option) => (
                      <option key={option.key} value={option.key}>
                        {option.keyValue}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-4 p-2">
                  <select
                    className="form-select form-control red-shadow border-r4"
                    aria-label="Default select example"
                    ref={statusRef}>
                    {[
                      { value: 0, key: "UI_All" },
                      { value: 1, key: "UI_Active" },
                      { value: 2, key: "UI_InActive" },
                    ].map(({ value, key }) => (
                      <option key={value} value={value}>
                        {selectedLanguage.LstLanguageCodes[key]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-4 p-2">
                  <input
                    placeholder={selectedLanguage.LstLanguageCodes.UI_UserName}
                    type="text"
                    className="red-shadow border-r4 admin-inputs form-control"
                    id="userName-admin"
                    ref={userNameRef}></input>
                  <div
                    className="admin-inputs-close admin-inputs-user-close"
                    onClick={(e) => (userNameRef.current.value = "")}>
                    X
                  </div>
                </div>
              </div>
              <div className="col-sm-2">
                <button
                  className="btn btn-primary mx-3 serchicon admin-search-button"
                  type="button"
                  onClick={onSearchHandler}>
                  <span className="material-icons top3px">search</span>
                </button>
              </div>
            </>
          )}
          {userRole === "RDocsSupportAdmin" && (
            <>
              <div className="col-sm-10 row">
                <div className="col-sm-3 p-2">
                  <select
                    className="form-select form-control red-shadow border-r4"
                    ref={roleRef}
                    id="ddlRoles"
                    aria-label="Default select example"
                    defaultValue={0}>
                    {lookupDataRoleOptions?.roleOptions?.map((option) => (
                      <option key={option.key} value={option.key}>
                        {option.keyValue}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-3 p-2">
                  <select
                    className="form-select form-control red-shadow border-r4"
                    aria-label="Default select example"
                    ref={statusRef}>
                    {[
                      { value: 0, key: "UI_All" },
                      { value: 1, key: "UI_Active" },
                      { value: 2, key: "UI_InActive" },
                    ].map(({ value, key }) => (
                      <option key={value} value={value}>
                        {selectedLanguage.LstLanguageCodes[key]}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-3 p-2">
                  <input
                    placeholder={selectedLanguage.LstLanguageCodes.UI_Company}
                    type="text"
                    className=" red-shadow border-r4 admin-inputs form-control"
                    id="companyName-admin"
                    ref={companyNameRef}></input>
                  <div className="admin-inputs-close" onClick={(e) => { companyNameRef.current.value = "" }}>X</div>
                </div>
                <div className="col-sm-3 p-2">
                  <input
                    placeholder={selectedLanguage.LstLanguageCodes.UI_UserName}
                    type="text"
                    className="red-shadow border-r4 admin-inputs form-control"
                    id="userName-admin"
                    ref={userNameRef}></input>
                  <div className="admin-inputs-close" onClick={(e) => { userNameRef.current.value = "" }}>X</div>
                  {/* <XIcon className='h-5' /> */}
                </div>
              </div>
              <div className="col-sm-2">
                <button
                  className="btn btn-primary mx-3 serchicon admin-search-button"
                  type="button" onClick={onSearchHandler}>
                  <span className="material-icons top3px">search</span>
                </button>
              </div>
            </>
          )}
        </div>
        {userRole === "RDocsSupportAdmin" && showUserDetails && (
          <UserDetails userRoleOptions={userRoleOptions} ref={userDetailsRef} getUserDetails={getUserDetails} />
        )}
        {userRole === "RDocsCustomerAdmin" && (
          <UserDetails userRoleOptions={userRoleOptions} ref={userDetailsRef} getUserDetails={getUserDetails} />
        )}
      </div>
    </>
  );
}
